import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteInfo } from '../data/mock';
import { Button } from './ui/button';
import { ChevronDown, MapPin, Car, Users } from 'lucide-react';

const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToTours = () => {
    document.querySelector('#tours')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTransfers = () => {
    document.querySelector('#transfers')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1559998560-deb30d24ea50?w=1920&q=80)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-32 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
          <MapPin className="w-4 h-4 text-teal-400" />
          <span className="text-white/90 text-sm font-medium">Bali, Indonesia</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          {t.hero.title}
        </h1>

        <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto mb-10 leading-relaxed">
          {t.hero.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Button
            onClick={scrollToTours}
            className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-lg rounded-lg shadow-lg shadow-teal-900/30 transition-all hover:scale-105"
          >
            {t.hero.cta}
          </Button>
          <Button
            onClick={scrollToTransfers}
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-stone-900 px-8 py-6 text-lg rounded-lg transition-all"
          >
            {t.hero.ctaSecondary}
          </Button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto">
          <div className="text-center">
            <div className="flex justify-center mb-2">
              <Car className="w-6 h-6 text-teal-400" />
            </div>
            <div className="text-3xl font-bold text-white">10+</div>
            <div className="text-white/60 text-sm">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="flex justify-center mb-2">
              <Users className="w-6 h-6 text-teal-400" />
            </div>
            <div className="text-3xl font-bold text-white">5000+</div>
            <div className="text-white/60 text-sm">Happy Guests</div>
          </div>
          <div className="text-center">
            <div className="flex justify-center mb-2">
              <MapPin className="w-6 h-6 text-teal-400" />
            </div>
            <div className="text-3xl font-bold text-white">50+</div>
            <div className="text-white/60 text-sm">Destinations</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-8 h-8 text-white/60" />
      </div>
    </section>
  );
};

export default HeroSection;